import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordGuide() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/islamicguide-61"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Bitcoin Guide for Muslims</h3>
        <p className="story-text">
          <p className="story-text">
            Muslims have historically been at the forefront of innovation,
            scholarship, and intellectual advancement. Cities such as Baghdad,
            Cairo, and Damascus once stood as global centers of learning across
            diverse sciences. This legacy reflects Islam’s encouragement of
            knowledge, critical thinking, and engagement with the world.
            <br />
            <br />
            At the same time, our dīn teaches us to carefully evaluate every
            innovation and technology through the principles of Islam before
            adopting or advocating for it. No tool, system, or idea is accepted
            blindly; rather, it is weighed against the Qur’an, the Sunnah, and
            the established principles of Islamic jurisprudence.
            <br />
            <br />
            This section seeks to fulfill that responsibility. It examines
            Bitcoin at a foundational level and explores how its core rules and
            design principles align with Islamic concepts of wealth, ownership,
            justice, and financial privacy. It also addresses some of the
            primary doubts and concerns Muslims commonly raise about Bitcoin,
            approaching them with clarity, reason, and evidence. The goal of
            this section is not to impose conclusions, but to equip the learner
            with the understanding needed to critically assess Bitcoin through
            an Islamic lens, allowing informed and conscientious judgment.
            <br />
            <br /> The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity.{" "}
          </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordGuide;
